import { type ComponentType } from "react"
import { IconBolt, IconFire, type IconProps } from "@octopus-energy/icons"
import { getMapKeyOr } from "@oefr/utils/maps"
import { type Maybe } from "@oefr/utils/types"
import { MarketName } from "@/constants/marketName"

const MARKET_NAME_ICON_MAP = {
    [MarketName.FRA_ELECTRICITY]: IconBolt,
    [MarketName.FRA_GAS]: IconFire,
} satisfies Record<MarketName, ComponentType<IconProps>>

export function getMarketNameIcon(marketName: Maybe<string>) {
    return getMapKeyOr(marketName, MARKET_NAME_ICON_MAP, null)
}
